import React from 'react'
import {
	Drawer, List, Row, Space, Tag, Typography
} from 'antd'
import { CloseOutlined, CheckCircleOutlined, PhoneOutlined, StopOutlined, FrownOutlined, SmileOutlined } from '@ant-design/icons'

export interface ITelephoneSurveyListItem {
	id: number
	callStatus: string
	satisfaction: string | null
	calledAt: string
	note?: string | null
	jobs: { id: number; address: string }[]
}

interface Props {
	items: ITelephoneSurveyListItem[]
	open: boolean
	onClose: () => void
	title?: string
}

const TelephoneSurveysDetailDrawer: React.FC<Props> = ({
	items, open, onClose, title = 'Telefonické prieskumy – detail'
}) => (
	<Drawer
		title={
			<Row justify="space-between" align="middle">
				<Space>
					<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
					<Typography.Text strong>{title}</Typography.Text>
				</Space>
			</Row>
		}
		width={700}
		visible={open}
		onClose={onClose}
		closeIcon={null}
	>
		<List
			itemLayout="vertical"
			dataSource={items}
			locale={{ emptyText: 'Žiadne záznamy' }}
			renderItem={(item) => {
				const answered = item.callStatus === 'ANSWERED'
				const satisfied = item.satisfaction === 'SATISFIED'
				const unsatisfied = item.satisfaction === 'UNSATISFIED'

				return (
					<List.Item key={item.id}>
						<Row justify="space-between" align="top">
							<Space wrap>
								{answered ? (
									<Tag icon={<PhoneOutlined />} color="green">Zdvihol</Tag>
								) : (
									<Tag icon={<StopOutlined />} color="default">Nedvíhal</Tag>
								)}
								{satisfied && (
									<Tag icon={<SmileOutlined />} color="blue">Spokojný</Tag>
								)}
								{unsatisfied && (
									<Tag icon={<FrownOutlined />} color="volcano">Nespokojný</Tag>
								)}
								<Typography.Text type="secondary" style={{ fontSize: 12 }}>
									{item.calledAt}
								</Typography.Text>
							</Space>
						</Row>

						{item.jobs.length > 0 && (
							<Row style={{ marginTop: 6 }}>
								<Space wrap>
									{item.jobs.map((job) => (
										<Tag key={job.id} color="blue">{job.address}</Tag>
									))}
								</Space>
							</Row>
						)}

						{item.note && (
							<Typography.Paragraph
								style={{ marginTop: 8, color: '#555', fontStyle: 'italic' }}
							>
								{item.note}
							</Typography.Paragraph>
						)}
					</List.Item>
				)
			}}
		/>
	</Drawer>
)

export default TelephoneSurveysDetailDrawer
